export default "__VITE_ASSET__DevMFKPO__"